<!-- <div id="single-product" class="single-product">    
    <product-meta></product-meta>
   
    <product-content></product-content>
</div> -->
<div class="prodDetailWrap">
    <product-meta [total]="total" [quantity]="quantity" [wishYn]="wishYn" (changeMinus)="handleOnClickMinus($event);" (changePlus)="handleOnClickPlus($event);" (changeWish)="onClickWishList($event);"></product-meta>
    <product-content [totalAmt]="total" [quantity]="quantity" [pdtInfo]="pdtInfo" [wishYn]="wishYn" (changeMinus)="handleOnClickMinus($event);" (changePlus)="handleOnClickPlus($event);" (changeWish)="onClickWishList($event);"></product-content>
</div>